const routes = {
  about: '/datos-abiertos',
  aboutDataGoal: '/datos-abiertos/objetivos-datos',
  aboutDefinitions: '/datos-abiertos/definiciones',
  aboutSiteGoal: '/datos-abiertos/objetivos-sitio',
  aboutSuggestData: '/datos-abiertos/sugerir-datos',
  aboutVideoTutorials: '/datos-abiertos/videotutoriales',
  comparator: '/comparador',
  contingencies: '/contingencias',
  downloads: '/descargas',
  downloadAddons: '/descargas/complementos',
  downloadDevelopmentTools: '/descargas/herramientas',
  downloadFramework: '/descargas/convenio-marco',
  downloadOCDS: '/descargas/procesos-ocds',
  downloadOrderAndBiddings: '/descargas/ordenes-y-licitaciones',
  downloadAgilePurchase: '/descargas/compra-agil',
  downloadLargePurchaseProcesses: '/descargas/procesos-compra-grandes',
  downloadPurchasePlan: '/descargas/plan-anual-compra',
  downloadContracts: '/descargas/contratos',
  organization: '/ficha-organismo/:idEntity',
  organizations: '/organismos-compradores',
  provider: '/organismos-proveedores/:dni',
  providers: '/organismos-proveedores',
  regionalInfo: '/informacion-regional/:regionSlug',
  root: '/',
  sector: '/organismos-compradores/:sectorSlug',
  agilePurchase: '/compra-agil',
  smallerCompanies: '/empresas-menor-tamanio',
  downloadCfmp: '/descargas/registro-compras-fuera-de-mercado-publico'
}

export default routes
